// extracted by css-extract-rspack-plugin
export default {"chevron":"DisclosureChevron-module__chevron__E8Xb8"};